// Used to view automatically enriched or manual updated contact attributes
// contactAttributes values should have more priorities then enrichmentAttributes and
// enrichmentAttributes values used only WHEN contactAttributes[values] IS null OR undefined
/**
 * @param {Object} contact
 * @param {(null | Object)} contact.contactAttributes
 * @param {(null | Object)} contact.enrichmentAttributes
 */
export const getActualContactAttributesView = (contact) => {
  if (!contact) return null

  const { contactAttributes, enrichmentAttributes, ...restContact } = contact
  const contactAttributesObject = contactAttributes || {}
  const enrichmentAttributesObject = enrichmentAttributes || {}

  const contactAttributesKeys = new Set([
    ...Object.keys(contactAttributesObject),
    ...Object.keys(enrichmentAttributesObject)
  ])

  const actualContactAttributes = {}
  for (const key of contactAttributesKeys) {
    const contactAttrValue = contactAttributesObject[key]
    const enrichmentAttrValue = enrichmentAttributesObject[key]

    actualContactAttributes[key] = contactAttrValue === null || contactAttrValue === undefined
      ? enrichmentAttrValue
      : contactAttrValue
  }

  return { ...restContact, contactAttributes: actualContactAttributes }
}
